import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'x-textarea-autosave',
  templateUrl: './textarea-autosave.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-textarea-autosave' },
})
export class TextareaAutosaveComponent implements OnInit, OnDestroy {
  private _subscription: Subscription = new Subscription();

  @Input() loading: boolean;
  @Input() title: string;
  @Input() subTitle: string;
  @Input() placeholder: string;
  @Input() maxLength: number = 200;

  @Input() set value(val: string | null) {
    if (!val) {
      this.control.patchValue('', { emitEvent: false });
      return;
    }

    if (this.control.touched) return;

    this.control.patchValue(val, { emitEvent: false });
    this.control.markAsTouched();
  }

  control = new FormControl<string>('', { nonNullable: true });

  @Output() messageUpdated = new EventEmitter<string>();

  ngOnInit(): void {
    this._subscription.add(
      this.control.valueChanges.pipe(debounceTime(500)).subscribe((val) => {
        this.messageUpdated.emit(val);
      }),
    );
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }
}
